export const GIFTING_COUPON_MODAL_TEST_IDS = {
    MODAL: "gifting-coupon-modal",
    CLOSE_BTN: "gifting-coupon-modal-close-btn",
    TIMER_CONTAINER: "gifting-coupon-modal-timer-container",
    TITLE: "gifting-coupon-modal-title",
    SUBTITLE: "gifting-coupon-modal-subtitle",
    DESCRIPTION: "gifting-coupon-modal-description",
    CTA_BUTTON: "gifting-coupon-modal-cta-button",
    IMAGE: "gifting-coupon-modal-image",
    IMAGE_CONTAINER: "gifting-coupon-modal-image-container",
};
